import gql from 'graphql-tag';
import { basicMemberFields } from './GetMember';

const key = `ListManagers`;

export function createListManagersQuery(managerRoleIds = []) {
  if (managerRoleIds.length === 0) throw 'Manager role ids should not be empty';
  const query = gql`
  query ${key} {
    listMembers(limit: 999, filter:{or:[
      ${managerRoleIds.map(roleId => `{memberRoleId:{eq:"${roleId}"}}`).join(`,
      `)}
    ]}) {
      items {
        ${basicMemberFields}
      }
    }
  }
  `;
  return { key, query };
}
